import Ajax from "./Ajax"
const GetState = async() => {
    const response = await Ajax({
        url: '/setting/getState?limit=false',
        token: true
    })
    return response.data.result
}
export default GetState